import { useState } from 'react';
import styled from 'styled-components';
import { Home } from './Pages/Home';
import { About } from './Pages/About';
import { Skills } from './Pages/Skills';
import { Portfolio } from './Pages/Portfolio';
import { Blog } from './Pages/Blog';
import { Contact } from './Pages/Contact';
import { Route, Switch as Switching } from 'react-router';
import { IconButton } from '@material-ui/core';
import { Sidebar } from './Components/Navigation/Sidebar';
import MenuIcon from '@material-ui/icons/Menu';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

const App = () => {
  const [navToggle, setNavToggle] = useState(false);
  const handleSideBar = () => setNavToggle(!navToggle);

  return (
    <div className='App'>
      <Sidebar navToggle={navToggle} />

      <HamburgerMenuStyled>
        <IconButton onClick={handleSideBar}>
          {!navToggle ? <MenuIcon /> : <ExitToAppIcon />}
        </IconButton>
      </HamburgerMenuStyled>

      <MainContentStyled>
        <Switching>
          <Route path='/' exact>
            <Home />
          </Route>
          <Route path='/about' exact>
            <About />
          </Route>
          <Route path='/skills' exact>
            <Skills />
          </Route>
          <Route path='/portfolio' exact>
            <Portfolio />
          </Route>
          <Route path='/blog' exact>
            <Blog />
          </Route>
          <Route path='/contact' exact>
            <Contact />
          </Route>
        </Switching>
      </MainContentStyled>
    </div>
  );
};

const MainContentStyled = styled.main`
  position: relative;
  margin-left: 16.3rem;
  min-height: 100vh;
  @media screen and (max-width: 1200px) {
    margin-left: 0;
  }
`;

const HamburgerMenuStyled = styled.div`
  position: fixed;
  top: 2rem;
  right: 2rem;
  z-index: 15;
  display: none;

  svg {
    font-size: 3rem;
  }

  @media screen and (max-width: 1200px) {
    display: block;
  }
`;

export default App;
